import {useEffect,useState} from 'react'
import {useSelector,useDispatch} from 'react-redux'
import {
	getClasses,
	updateEditor,
	updateMessenger,
	registerForFree,
	deleteLiveClass,
	updateParticipants,
} from '../liveClassesSlice'
import {copyToClipboard} from '../../../util/util'
import {
	getIsFree,
	getPriceText
} from '../helpers'
import Card from 'react-bootstrap/Card'
import Badge from 'react-bootstrap/Badge'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import Tooltip from 'react-bootstrap/Tooltip'
import Dropdown from 'react-bootstrap/Dropdown'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import DropdownButton from 'react-bootstrap/DropdownButton'
import {selectCurrencyById} from '../../settings/settingsSlice'
import {getCurrencySymbol} from '../../../util/intl'
import DiscussResourceButton from '../../DiscussResourceButton/DiscussResourceButton'
import styles from '../LiveClasses.module.css'

const PriceButton = ({ liveClass , openRegisterModal, loadingCheckout }) => {
	const [status,setStatus] = useState('idle')
	const acceptedCurrency = useSelector(
		state => selectCurrencyById(state,liveClass.presentment_currency_id)
	)
	const taxPercent = useSelector(state=>state.settings.app.tax_percent)
	const dispatch = useDispatch()
	const user = useSelector(state=>state.users.current_user)
	const isRegistered = liveClass.token !== null
	const variant = isRegistered ? 'outline-success' : 'outline-primary'
	const isFree = getIsFree(liveClass)
	const price = ((
			liveClass.advancedPricing == 1?
			liveClass.clientPrice:
			liveClass.price
		)*(1+taxPercent/100)).toFixed(2)
	const priceText = (
		getIsFree(liveClass) ?
		'Free' :
		`${getCurrencySymbol(acceptedCurrency?.ISO)}${price} (${acceptedCurrency?.ISO})`
	)
	const buttonText = isRegistered ? 'Join Now' : `Register ${priceText}`
	const spotsLeft = parseInt(liveClass.max_size)-parseInt(liveClass.class_size)

	const handleRegisterForFree = ()=>{
		setStatus('pending')
		dispatch(registerForFree({class_id:liveClass._id}))
		.then((action)=>{
			if(action.payload.success === '0'){
				alert(action.payload.message)
			}else{
				return dispatch(getClasses())
			}
		})
		.then(()=>{
			setStatus('idle')
		})
		.catch(()=>{
			setStatus('idle')
		})
	}

	const handleRegister = ()=>{
		openRegisterModal(liveClass)
	}

	const handleJoinNow = ()=>{
		const url =  `/live_class?room_id=${liveClass._id}&cn=${liveClass.crypto_name}&t=${liveClass.token}&user_id=${user.user_id_number}`
		window.location = url
	}

	const clickHandler = (
		isRegistered ?
		handleJoinNow :
		(
			isFree ?
			handleRegisterForFree :
			handleRegister
		)
	)

	return (
		spotsLeft || isRegistered ?
		<Button 
			disabled={status==='pending'||loadingCheckout}
			onClick={clickHandler} 
			variant={variant} 
			size="sm"
		>
			<span className="mr-1">{buttonText}</span>
			{(status==='pending'||loadingCheckout)&&<Spinner size="sm" animation="border"/>}
		</Button>
		:
		<small className="text-danger">Class is full</small>
	)
}

const TrainerOptions = ({liveClass,layoutType}) => {
	const user = useSelector(state=>state.users.current_user)
	const canShowOnFTG = user.can_show_on_ftg
	//used to copy to clipboard and for sharing to FB/Twitter
	const dispatch = useDispatch()
	const owner_id = parseInt(user.gym_id) !== 0 ? user.gym_id : user.user_id_number
	const shareLink = `https://findtraingain.com/live-classes-search-results.php?openClass=${liveClass._id}&trainer=${owner_id}`;
	const handleDelete = ()=>{
		if(!window.confirm('Are you sure?')) return 
		dispatch(deleteLiveClass({
			class_id:liveClass._id,
			crypto_name:liveClass.crypto_name
		}))
	}
	const handleNotifyClients = ()=>{
		dispatch(updateMessenger({
			show:true,
			id:liveClass._id
		}))
	}
	
	return (
		<DropdownButton
			variant="outline-primary"
			title="Options"
			drop={layoutType==='grid'?"up":'left'}
			size="sm"
		>
			{!liveClass.isPast&&
				<>
					<Dropdown.Item
						onClick={()=>{
							const url =  `/live_class?room_id=${liveClass._id}&cn=${liveClass.crypto_name}&t=${liveClass.token}&user_id=${user.user_id_number}`
							window.location = url
						}}
					>
						Join
					</Dropdown.Item>
					<Dropdown.Item
						onClick={()=>{
							dispatch(updateEditor({
								show:true,
								id:liveClass._id
							}))
						}}
					>
						Edit
					</Dropdown.Item>
				</>
			}
			<Dropdown.Item
				onClick={()=>{
					dispatch(updateParticipants({
						show:true,
						id:liveClass._id
					}))
				}}
			>
				View Participants
			</Dropdown.Item>
			<Dropdown.Item onClick={handleDelete} style={{color:"#dc3545"}}>
				Delete
			</Dropdown.Item>
			{!liveClass.isPast&&
				<>
					<Dropdown.Header>Share Options</Dropdown.Header>
					<Dropdown.Item onClick={handleNotifyClients}>
						Notify Clients
					</Dropdown.Item>
					{(liveClass.isPublic === '1'&&user.can_show_on_ftg)&&
						<>
							{canShowOnFTG&&
								<Dropdown.Item onClick={()=>{
									copyToClipboard(shareLink)
								}}>
									Copy Link
								</Dropdown.Item>
							}
							<Dropdown.Item 
								target="_blank"
								href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareLink)}`}
							>
								Facebook
							</Dropdown.Item>
							<Dropdown.Item 
								target="_blank"
								href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(shareLink)}`}
							>
								Twitter
							</Dropdown.Item>
						</>
					}
				</>
			}
		</DropdownButton>
	)
}

const ClassCard = ({liveClass,openRegisterModal,layoutType,loadingCheckout})=>{
	const acceptedCurrency = useSelector(state=>selectCurrencyById(state,liveClass.presentment_currency_id))
	const user = useSelector( state => state.users.current_user )
	return (
		<div className={[
			styles.ClassCard,
			layoutType==='grid'?styles.Grid:styles.List
		].join(' ')}>
			<div>
				<div className={[
					styles.CardHeader,
					layoutType==='grid'?styles.Grid:styles.List
				].join(' ')}>
					<OverlayTrigger overlay={
						<Tooltip>{liveClass.title}</Tooltip>
					}>
						<strong className={styles.CardTitle}>
							{liveClass.title}
						</strong>
					</OverlayTrigger>
					<div className={[
						styles.CardDateInfo,
						layoutType==='grid'?styles.Grid:styles.List
					].join(' ')}>
						<small className="text-primary">{liveClass.startDatePretty}</small>
						<small>{`${liveClass.duration} mins`} @ {liveClass.startTimePretty}</small>
					</div>
				</div>
			</div>
			<div className={styles.CardBody}>
				<div style={{fontSize:'14px'}}>{liveClass.description}</div>
				<div className={[
					styles.CardBodyInfo,
					layoutType==='grid'?styles.Grid:styles.List
				].join(' ')}>
					<div className={styles.CardInfoItem}>
						<small>
							<span className="text-muted">Equipment:</span> {liveClass.equipment.join(', ')}
						</small>
					</div>
					<div className={styles.CardInfoItem}>
						<small>
							<span className="text-muted">Training type:</span> {liveClass.trainingTypes.join(', ')}
						</small>
					</div>
					{
						liveClass.advancedPricing === '1' ?
						<>
							<div className={styles.CardInfoItem}>
								<small>
									<span className="text-primary">Client Price</span>: {
										liveClass.clientFree === '1'?
										'Free':
										`${getCurrencySymbol(acceptedCurrency?.ISO)}${liveClass.clientPrice} (${acceptedCurrency?.ISO})`
									}
								</small>
							</div>
							<div className={styles.CardInfoItem}>
								<small>
									<span className="text-primary">Public Price</span>: {
										liveClass.publicFree === '1'?
										'Free':
										`${getCurrencySymbol(acceptedCurrency?.ISO)}${liveClass.publicPrice} (${acceptedCurrency?.ISO})`
									}
								</small>
							</div>
						</>
						:
						<div className={styles.CardInfoItem}>
							<small>
								<span className="text-primary">Price</span>: {getCurrencySymbol(acceptedCurrency?.ISO)}{liveClass.price} ({acceptedCurrency?.ISO})
							</small>
						</div>
					}
					<div className={styles.CardInfoItem}>
						<small >
							<span className="text-info">Spots Left:</span> {parseInt(liveClass.max_size)-parseInt(liveClass.class_size)}
						</small>
					</div>
					{liveClass.isPublic==='1'&&
						<div className={styles.CardInfoItem}>
							<OverlayTrigger overlay={
								<Tooltip>This class is available to general public</Tooltip>
							}>
								<Badge variant="primary">Public</Badge>
							</OverlayTrigger>
						</div>
					}
				</div>
			</div>
			<div>
				<div className="d-flex justify-content-end">
					{
						user?.account_type === 'client' ?
						<PriceButton liveClass={liveClass} openRegisterModal={openRegisterModal} loadingCheckout={loadingCheckout}/>
						:
						<TrainerOptions liveClass={liveClass} layoutType={layoutType}/>
					}
				</div>
				<OverlayTrigger overlay={
					<Tooltip>Discuss this class in the chat</Tooltip>
				}>
					<span className="ml-auto">
						<DiscussResourceButton
							className="btn btn-sm btn-outline-info my-1"
							name={liveClass.title}
							id={liveClass._id}
							type="live_class"
						>
							<i className="fa fa-comments"/>
						</DiscussResourceButton>
					</span>
				</OverlayTrigger>
			</div>
		</div>
	)
}
export default ClassCard